module.exports = __webpack_public_path__ + "static/img/pic-efficient-tech.6a8741a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/assets/pic-efficient-tech.png
// module id = k7gt
// module chunks = 1